/**
 * @ngdoc directive
 * @module components.anchor
 * @name components.anchor:anchorContainer
 * @scope
 * @restrict E
 * @description
 * A container for anchor links (links that scroll to a section of the page when clicked).
 * @param {string=} scrollContainer Sets the scrollable region to watch for updates so that active states can be added to the links as the user scrolls. If left empty, it defaults to 'body, html.'
 * @param {string=} activeClass Sets the class anchors will use when they are active. Defaults to 'active' if left empty.
 * @param {function=} onRegister Callback function that fires when new anchors are registered to the container.
 * - anchor: reference to the anchor controller that was registered
 * @param {function=} onChange Callback function that fires when the active section changes.
 * - anchor: reference to the anchor controller that became active
 */
(function () {
    angular.module('components.anchor')
        .component('anchorContainer', {
            bindings: {
                scrollTarget: '@?',
                activeClass: '@?',
                onRegister: '&?',
                onChange: '&?'
            },
            controller: anchorContainerController
        });

    anchorContainerController.$inject = ['$window', '$timeout'];
    function anchorContainerController($window, $timeout) {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl.anchors = [];
            ctrl.$scrollTarget = angular.element(ctrl.scrollTarget || $window);
            ctrl.$scrollTarget.on('scroll.anchor-' + ctrl.target, ctrl.$$updateAnchors);
        }

        ctrl.register = function (anchor) {
            ctrl.anchors.push(anchor);
            if (ctrl.onRegister) {
                ctrl.onRegister({ anchor: anchor });
            }
        }

        ctrl.$$updateAnchors = function (status) {
            var last;
            $timeout(function () {
                for (var i = 0; i < ctrl.anchors.length; i++) {
                    var anchor = ctrl.anchors[i];
                    if (anchor.isPassed()) {
                        last = i;
                    }
                    else {
                        break;
                    }
                }
                for (var i = 0; i < ctrl.anchors.length; i++) {
                    ctrl.anchors[i].setActive(i === last);
                }
                if (ctrl.onChange) {
                    if (last === undefined) {
                        ctrl.onChange({ anchor: null });
                    }
                    else {
                        ctrl.onChange({ anchor: ctrl.anchors[last] });
                    }
                }
            })
        }

        ctrl.$onDestroy = function () {
            ctrl.$scrollTarget.off('scroll.anchor-' + ctrl.target);
        };
    }
})();